import { Component, DestroyRef, HostBinding, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Domain } from '../../shared/models/domain';
import { AuthSubscriptionsService } from '../../shared/services/auth-subscriptions/auth-subscriptions.service';
import { LanguageService, LanguageCode } from '../../shared/services/language/language.service';
import * as AuthActions from '../../store/auth/auth.actions';
import { AuthState } from '../../store/auth/auth.reducer';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'urban-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: false
})
export class AuthComponent implements OnInit {

  @HostBinding('class') className = 'authLight';

  public appVersion: string = environment.appVersion;

  private readonly store = inject(Store<AuthState>)
  private readonly authService = inject(AuthSubscriptionsService);
  private readonly router = inject(Router);
  private readonly language = inject(LanguageService);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  public readonly languages: LanguageCode[] = this.language.available;

  private readonly darkThemeRoutes: string[] = ['app-activation', 'confirm-delete'];

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.className = this.darkThemeRoutes.some(route => this.router.url.includes(route)) ? 'authMode' : 'authLight';
    });

    this.authService.getSetErrorComand().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(target => {
      if (target) this.setError(target);
    });
    this.authService.getRequestLoginComand().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(target => {
      if (target) this.requestLogin(target);
    });
    this.authService.getInitSetUserDomainComand().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(target => {
      if (target) this.initSetUserDomain(target);
    });
  }

  public requestLogin(bodyLogin: { username: string, password: string }): void {
    this.store.dispatch(AuthActions.requestLogin(bodyLogin));
  }

  public setError(errorToSet: { error: string }): void {
    this.store.dispatch(AuthActions.setError(errorToSet));
  }

  public initSetUserDomain(domain: Domain): void {
    this.store.dispatch(AuthActions.initSetUserDomain(domain));
  }

  public get currentLanguage(): LanguageCode {
    return this.language.current;
  }

  public useLanguage(language: LanguageCode): void {
    this.language.use(language);
  }
}
